import {useState} from 'react';
import {Col, Row} from "antd";
import {VendorSelectWidget} from "../widget/VendorSelectWidget";


export const VendorWidget = ({disabled, placeholder, vendor, onVendorChange, refresh, onRefresh, onApiFail, props}) => {
    const [active, setActive] = useState(false);

    const onClick = () => {
        if (disabled === true) {
            // disabled pickers can not be changed
            return;
        }
        setActive(true);
    }

    const onVendorIdChange = (vendorName, option) => {
        const {vendor} = option;
        if (onVendorChange) {
            const {id: vendorId} = vendor;
            onVendorChange(vendorId);
        }
        setActive(false);
    }


    const onBlur = () => {
        if (active === true) {
            setTimeout(() => {
                setActive(false);
            }, 200);
        }
    }

    let vendorContent;
    if (vendor) {
        vendorContent = vendor;
    } else {
        vendorContent = placeholder;
    }

    if (active) {
        return <VendorSelectWidget refresh={refresh} onApiFail={onApiFail} onSelect={onVendorIdChange} onBlur={onBlur}/>;
    } else {
        return <div style={{cursor: "pointer", color: "#108ee9", marginTop: '5px'}} onClick={onClick}>
            <Row>
                <Col style={{marginRight: '5px'}}>
                    {vendorContent}
                </Col>
            </Row>

        </div>
    }
}